import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'circular-progress',
  templateUrl: './circular-progress.component.html',
  styleUrls: ['./circular-progress.component.scss']
})
export class CircularProgressComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
